import { $win } from '../utils/globals';

$('.js-top').on('click', function(e){
	e.preventDefault();

	$( 'html, body' ).animate({
		scrollTop: $( 'body' ).offset().top
	}, 1000);
})

$win.on('load', function(){
	let $descButton = $('.js-description');
	let $description = $('.section-post .section__description').children().slice(1);

	if ( $('.js-description').length ) {
		if ( $description.length < 2 ) {
			$descButton.hide()
		} else {
			$descButton.on('click', function(e){
				e.preventDefault();
				let $this = $(this);

				if ( $this.hasClass('is-open') ) {
					$description.slideUp();
					$this.removeClass('is-open').text('Read Full Description');
				} else {
					$description.slideDown();
					$this.addClass('is-open').text('Close Description');
				}
			})
		}
	}
})

$('.nav-trigger').on('click', function(e){
	e.preventDefault();
	let $navItems = $('.mobile-menu').find('li');

	if ( $('body').hasClass('mobile-open') ) {
		$('body').removeClass('mobile-open');
		$('.mobile-menu').removeClass('is-open');

		$navItems.each(function(i){
			$(this).removeClass('show');
		})
	} else {
		$('body').addClass('mobile-open');
		$('.mobile-menu').addClass('is-open');

		$navItems.each(function(i){
			let $this = $(this)

			setTimeout(function(){
				$this.addClass('show');
			}, 100 * (i + 2) );
		})
	}
})
